enum breakpoints {
  'DESKTOP' = 1280,
  'TABLET' = 768,
  'MOBILE' = 320,
  'LargeMobile' = 480,
}

export default breakpoints;
